import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ListItemButton, ListItemIcon, ListItemText, ListSubheader, Link, Tooltip } from '@mui/material';
import PollIcon from '@mui/icons-material/Poll';
import SchoolIcon from '@mui/icons-material/School';
import WavesIcon from '@mui/icons-material/Waves';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EventNoteIcon from '@mui/icons-material/EventNote';

// Icon style to match link color
const iconStyle = {
  color: 'secondary.main'
};

const labelStyle = {
  fontSize: '1rem',
  fontWeight: 'bold',
  color: 'text.primary',
  letterSpacing: '0.01em',
  marginBottom: '8px',
  fontFamily: '"Gilroy", sans-serif',
}

export const mainListItems = (
  <React.Fragment>
    {/* <Link 
      component={RouterLink} 
      to="/ama/snapshots" 
      underline="none" 
      color="primary"
      sx={{ display: 'block' }}
    >
      <Tooltip title="Aid Matriculation Analysis" placement="right" arrow>
        <ListItemButton>
          <ListItemIcon sx={iconStyle}>
            <SchoolIcon />
          </ListItemIcon>
          <ListItemText sx={labelStyle} primary="AMA" />
        </ListItemButton>
      </Tooltip>
    </Link> */}

    <Link 
      component={RouterLink} 
      to="/ama-v2/clients" 
      underline="none" 
      color="primary"
      sx={{ display: 'block' }}
    >
      <Tooltip title="Aid Matriculation Analysis v2" placement="right" arrow>
        <ListItemButton>
          <ListItemIcon sx={iconStyle}>
            <SchoolIcon />
          </ListItemIcon>
          <ListItemText sx={labelStyle} primary="AMA v2" />
        </ListItemButton>
      </Tooltip>
    </Link>    

    
    <Link
      component={RouterLink}
      to="/jobs"
      underline="none"
      color="primary"
      sx={{ display: 'block' }}
    >
      <Tooltip title="Scheduled Jobs" placement="right" arrow>
        <ListItemButton>
          <ListItemIcon sx={iconStyle}>
            <ScheduleIcon />
          </ListItemIcon>
          <ListItemText sx={labelStyle} primary="Scheduled Jobs" />
        </ListItemButton>
      </Tooltip>
    </Link>

    <Link
      component={RouterLink}
      to="/events"
      underline="none"
      color="primary"
      sx={{ display: 'block' }}
    >
      <Tooltip title="Events" placement="right" arrow>
        <ListItemButton>
          <ListItemIcon sx={iconStyle}>
            <EventNoteIcon />
          </ListItemIcon>
          <ListItemText sx={labelStyle} primary="Events" />
        </ListItemButton>
      </Tooltip>
    </Link>
    
    
    {/* <Link 
      component={RouterLink} 
      to="/asr" 
      underline="none" 
      color="primary"
      sx={{ display: 'block' }}
    >
      <Tooltip title="Admitted Student Review - View and analyze survey responses" placement="right" arrow>
        <ListItemButton>
          <ListItemIcon sx={iconStyle}>
            <PollIcon />
          </ListItemIcon>
          <ListItemText sx={labelStyle} primary="ASR" />
        </ListItemButton>
      </Tooltip>
    </Link> */}

    {/* <Link 
      component={RouterLink} 
      to="/sai" 
      underline="none" 
      color="primary"
      sx={{ display: 'block' }}
    >
      <Tooltip title="Strategic Academic Investment - Track investment initiatives" placement="right" arrow>
        <ListItemButton>
          <ListItemIcon sx={iconStyle}>
            <PriceChangeIcon />
          </ListItemIcon>
          <ListItemText sx={labelStyle}primary="SAI" />
        </ListItemButton>
      </Tooltip>
    </Link> */}
  </React.Fragment>
);

export const secondaryListItems = (
  <React.Fragment>
    <ListSubheader component="div" inset>
      Tools
    </ListSubheader>   
    
    <Link 
      component={RouterLink} 
      to="/dsm" 
      underline="none" 
      color="primary"
      sx={{ display: 'block' }}
    >
      <Tooltip title="Dynamic Schema Manager - Manage data schemas and attributes" placement="right" arrow>
        <ListItemButton>
          <ListItemIcon sx={iconStyle}>
            <DynamicFormIcon />
          </ListItemIcon>
          <ListItemText sx={labelStyle} primary="DSM" />
        </ListItemButton>
      </Tooltip>
    </Link>
    
    <Link 
      component={RouterLink} 
      to="/data-explorer" 
      underline="none" 
      color="primary"
      sx={{ display: 'block' }}
    >
      <Tooltip title="Data Lake Explorer - Browse and download data from the data lake" placement="right" arrow>
        <ListItemButton>
          <ListItemIcon sx={iconStyle}>
            <WavesIcon />
          </ListItemIcon>
          <ListItemText sx={labelStyle} primary="Data Lake" />
        </ListItemButton>
      </Tooltip>
    </Link>

    {/* Other commented list items with tooltips... */}
    {/* <Link 
      component={RouterLink} 
      to="/hsq" 
      underline="none" 
      color="primary"
      sx={{ display: 'block' }}
    >
      <Tooltip title="High School Quality - Evaluate and analyze high school quality metrics" placement="right" arrow>
        <ListItemButton>
          <ListItemIcon sx={iconStyle}>
            <AssuredWorkloadIcon />
          </ListItemIcon>
          <ListItemText sx={labelStyle}primary="High School Quality" />
        </ListItemButton>
      </Tooltip>
    </Link> */}
  </React.Fragment>
);